// extracted by mini-css-extract-plugin
export var attachButton = "_kp-8";
export var sendButton = "_kp-2";
export var sendDisabled = "_kp-4";
export var sendEnabled = "_kp-3";
export var sendIcon = "_kp-6";
export var sendIconDisabled = "_kp-7";
export var sendStreaming = "_kp-5";
export var textarea = "_kp-1";
export var wrapper = "_kp-0";